module.exports = __webpack_public_path__ + "static/media/pembagian_kelas_ekskul.9e8f5a6d.png";